import { GET_ALL_BADGES_REQUEST } from '../types';

export const getAllBadgesAction = () => ({
  type: GET_ALL_BADGES_REQUEST,
});
